import { useQuery } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';
import { useModal } from 'hooks';

export const useCompanyDetails = () => {
  const { isOpen, handleOpenModal, handleCloseModal } = useModal();

  const { data: companyDetailsResponse, isLoading } = useQuery(['company-details'], () =>
    API_HANDLERS.COMPANY.DETAILS(),
  );

  return {
    isLoading: isLoading,
    isOpen,
    handleOpenModal,
    handleCloseModal,
    company: companyDetailsResponse?.data,
  };
};
